import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpFromBracket } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const uploadIcon = <FontAwesomeIcon icon={faArrowUpFromBracket} />;

export const Dropzone = ({ uploadAttachments }) => {
  const { t } = useTranslation();

  const onDrop = useCallback((acceptedFiles) => {
    uploadAttachments(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <>
      <div>
        <Container {...getRootProps()}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <FlexWrapper>
              <IconWrapper>{uploadIcon}</IconWrapper>
              <p>Släpp filerna här ...</p>
            </FlexWrapper>
          ) : (
            <FlexWrapper>
              <IconWrapper>{uploadIcon}</IconWrapper>
              <p>{t('uploadFiles.dropAreaText')}</p>
            </FlexWrapper>
          )}
        </Container>
      </div>
    </>
  );
};

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.25rem;
  border: ${(props) => props.theme.fileDropArea.border};
  border-radius: ${(props) => props.theme.fileDropArea.borderRadius};
  background-color: ${(props) => props.theme.fileDropArea.backgroundColor};
  color: ${(props) => props.theme.fileDropArea.fontColor};
  font-size: ${(props) => props.theme.fileDropArea.fontSize};
  outline: none;
  transition: border 0.24s ease-in-out;
  margin: 0.25rem 0 0.75rem 0;
  cursor: pointer;

  p {
    margin-bottom: 0;
  }
`;

const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.75rem;
`;

const IconWrapper = styled.div`
  font-size: 1.563rem;
  align-self: center;
  color: ${(props) => props.theme.fileDropArea.iconColor};
`;
